import { render, staticRenderFns } from "./UsageRecordShow.vue?vue&type=template&id=460ace04&"
import script from "./UsageRecordShow.vue?vue&type=script&lang=js&"
export * from "./UsageRecordShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports